import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

const firstBy = window.firstBy;

const { moment } = window;

const renewal_paid_options =
[
	{
		name: 'quarter_page',
		label: 'Encart 1/4 de page (85 mm x 46 mm)'
	},
	{
		name: 'semi_page',
		label: 'Encart 1/2 page (85 mm x 95 mm)'
	},
	{
		name: 'full_page',
		label: 'Encart page entière (85 mm x 193 mm)'
	}
];

const app = window.app;

export var form =
{
	model: 'partner',

	form_title: 'Partenaire',

	filter_query:
	{
		sort: 'renewals ASC'
	},

	fields:
	{
		name:
		{
			label: 'Nom',
			front_indicator: true
		},

		disabled:
		{
			label: 'Désactivé',
			front_indicator: true,

			type: 'checkbox'
		},

		send_notifications:
		{
			label: 'Envoyer une notification',

			type: 'checkbox'
		},

		place:
		{
			label: 'Lieu',
			reference:
			{
				model: 'place',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				},
				autocomplete:
				{
					'name':
					{
						type: 'text'
					}
				}
			},
			front_indicator: true
		},

		address_1:
		{
			label: 'Adresse',
			front_indicator: true
		},

		address_2:
		{
			label: 'Complément d\'adresse',
			front_indicator: true
		},

		city:
		{
			label: 'Ville',
			front_indicator: true
		},

		zip_code:
		{
			label: 'Code postal',
			front_indicator: true
		},

		bill_name:
		{
			label: 'Nom de facturation (si différent nom partenaire)'
		},

		bill_address_1:
		{
			label: 'Adresse'
		},

		bill_address_2:
		{
			label: 'Complément d\'adresse'
		},

		bill_city:
		{
			label: 'Ville'
		},

		bill_zip_code:
		{
			label: 'Code postal'
		},

		'phone':
		{
			label: 'Téléphone',
			type: 'tel',
			front_indicator: true
		},

		'email':
		{
			label: 'E-mail',
			type: 'email',
			front_indicator: true
		},

		'website':
		{
			label: 'Site web'
		},

		'linkedin':
		{
			label: 'LinkedIn',
			front_indicator: true
		},

		'facebook':
		{
			label: 'Facebook',
			front_indicator: true
		},

		'instagram':
		{
			label: 'Instagram',
			front_indicator: true
		},

		'category':
		{
			label: 'Catégorie',
			reference:
			{
				model: 'category',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				},
				autocomplete:
				{
					'name':
					{
						type: 'text'
					}
				}
			},
			front_indicator: true
		},

		'highlighted':
		{
			label: 'Partenaire du moment (accueil)',
			type: 'checkbox',
			column: true
		},

		'mobile_app':
		{
			label: 'Affiché dans l\'application mobile',
			type: 'checkbox',
			column: true
		},

		'discount_infos':
		{
			label: 'Remise',
			type: 'editor',
			front_indicator: true,
			images: false
		},

		'informations':
		{
			label: 'Informations complémentaires',
			type: 'editor',
			front_indicator: true
		},

		'images':
		{
			type: 'image',
			label: 'Images',
			multiple: true,
			front_indicator: true
		},

		'logo':
		{
			type: 'image',
			label: 'Logo',
			multiple: false,
			front_indicator: true
		},

		'legal_code':
		{
			label: 'Code comptable'
		},

		export_cli_code:
		{
			label: 'Code client SAGE'
		},

		'pdfs':
		{
			type: 'pdf',
			multiple: true,
			label: 'PDFs d\'information'
		},

		'online_access':
		{
			label: 'Accès en ligne',
			type: 'checkbox'
		},

		'online_access_infos':
		{
			label: 'Texte explicatif',
			type: 'editor',
			show: data => [true, 'true'].includes(data['partner[online_access]'])
		},

		'online_access_url':
		{
			label: 'Adresse url',
			show: data => [true, 'true'].includes(data['partner[online_access]'])
		},

		place_themes:
		{
			label: 'Thèmes principaux',
			reference:
			{
				model: 'PlaceTheme'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				}
			},
			autocomplete: 'label'
		},

		custom_quotes:
		{
			label: 'Demandes de devis',
			reference:
			{
				model: 'CustomQuote'.toLowerCase(),
				referenced_field:
				{
					name: 'title',
					type: 'text'
				}
			},
			autocomplete: 'title'
		}
	},

	'create_label': 'Créer ce partenaire',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce partenaire&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['partner[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (data)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau partenaire <strong> { data.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/partenaires/' + data.id }>
						Voir le partenaire
					</Link>
				</div>
			</div>
		);

		return output;
	},

	collapses:
	[
		{
			title: 'Général',
			elements:
			[
				'name',
				'send_notifications',
				'disabled',
				'highlighted',
				'mobile_app',
				'category',
				'pdfs',
				'discount_infos',
				'informations'
			],
			order: -20
		},

		{
			title: 'Facturation',
			open: true,
			elements:
			[
				'bill_name',
				'bill_address_1',
				'bill_address_2',
				'bill_zip_code',
				'bill_city',

				'legal_code',
				'export_cli_code'
			],
			order: -15
		},

		{
			title: 'Adresse',
			open: true,
			elements:
			[
				'place',
				'address_1',
				'address_2',
				'zip_code',
				'city'
			],
			order: -10
		},

		{
			title: 'Contact',
			open: true,
			elements:
			[
				'website',
				'email',
				'phone',
				'linkedin',
				'facebook',
				'instagram'
			]
		},

		{
			title: 'Media',
			open: true,
			elements:
			[
				'images',
				'logo'
			]
		},

		{
			title: 'Accès en ligne',
			open: true,
			elements:
			[
				'online_access',
				'online_access_infos',
				'online_access_url'
			]
		}
	],

	views:
	[
		{
			title: 'Thèmes principaux',
			search_label: 'Chercher un thème principal',
			source_field: 'place_themes',
			add_label: 'Ajouter ce thème',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{
				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.label }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['label']
			}
		},
		{
			title: 'Demandes de devis',
			search_label: 'Chercher une demande de devis',
			source_field: 'custom_quotes',
			add_label: 'Ajouter cette demande de devis',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{

				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.title }
									{ ' (' + data.model_data.elements.length + ' champs )' }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['label']
			}
		}
	]
};

const YEAR = moment().month() >= 8
? moment().format('YYYY')
: moment().subtract(1, 'year').format('YYYY');

const renewal_status =
{
	pending: 'En attente',
	reminded: 'En attente (relancé)',
	no: 'Non',
	yes: 'Oui',
	none: 'Non envoyé'
};

var list =
{
	model        : 'partner',
	title        : 'Liste des partenaires',
	link         : '/partenaires',
	header_map:
	{
		'Nom'                : 'name',
		'Catégorie'          : 'category',
		'Téléphone'          : 'phone',
		'Adresse'            : 'city',
		'Mise en avant'      : 'highlighted',
		'Encart publicitaire': 'renewal_options',
		'Renouvelé'          : 'renewals'
	},

	creation_link : '/gestion-du-catalogue/nouveau-partenaire',
	creation_label: 'Nouveau partenaire',
	row_link_base: '/partenaires/',
	searched_prop: 'name',

	sortable_cols: ['category', 'renewals'],

	hookFetch: function ({ response, filter_query={ } })
	{
		let categories = (response.references || [])
		.find(data => data.model === 'category') || { };

		categories = categories.data || [];

		response.data = (response.data || []).map(function (partner)
		{
			partner._category = categories
			.find(category => category.id === partner.category);

			return partner;
		});

		if (filter_query.sort && filter_query.sort.startsWith('renewals '))
		{
			response.data = response.data.sort(
				firstBy(_renewal)
				.thenBy(_name)
			);

			if (filter_query.sort.endsWith(' DESC'))
			{
				response.data = response.data.reverse();
			}
		}
		else if (filter_query.sort && filter_query.sort.startsWith('category '))
		{
			response.data = response.data.sort(
				firstBy(_category)
				.thenBy(_name)
			);

			if (filter_query.sort.endsWith(' DESC'))
			{
				response.data = response.data.reverse();
			}
		}

		return response;
	},

	field_hook:
	{
		'Renouvelé': function (value, partner)
		{
			let status = 'none';

			if (value[YEAR]?.status === 'stopped')
			{
				status = 'no';
			}
			else if (value[YEAR]?.status === 'renewed')
			{
				status = 'yes';
			}
			else if (value[YEAR]?.status === 'reminded')
			{
				status = 'reminded';
			}
			else if (value[YEAR]?.status)
			{
				status = 'pending';
			}

			let output =
			(
				<div className={ 'partner-renewal-status ' + status }>
					<span>{ renewal_status[status] || '-' }</span>

					<button className="c-btn c-btn--smaller u-margin-left-15"
						type="button" onClick={ function (e)
							{
								app.emit('open__PartnerRenewalModal',
								{
									partner: partner
								});
							} }>
						+ Détails
					</button>

				</div>
			);

			return output;
		},

		'Encart publicitaire': function (value, partner)
		{
			const renewal = partner.renewals[YEAR] || { };

			if (renewal.status !== 'renewed') return null;

			const picked_options = ['quarter_page', 'semi_page', 'full_page']
			.filter(name => [true, 'true'].includes(renewal[name]))
			.map(function (field)
			{
				const infos = renewal_paid_options.find(opt => opt.name === field);

				const output =
				(
					<div className="partner-renewal-paid-options__row" key={ field }>
						{ infos.label }
					</div>
				);

				return output;
			});

			let output =
			(
				<div className="partner-renewal-paid-options">

					{
						picked_options.length === 0 && renewal.emailing ?
						(
							<div className="partner-renewal-paid-options__row">
								Une parution format annuaire (240€)
							</div>
						)
						: undefined
					}

					{ picked_options }

				</div>
			);

			return output;
		},

		'Mise en avant': function (value, partner)
		{
			return [true, 'true'].includes(value) ? 'Oui' : '';
		}
	}
};

function _renewal (a, b)
{
	if (!a.renewals?.[YEAR] || !a.renewals[YEAR].response_date) return 1;

	if (!b.renewals?.[YEAR] || !b.renewals[YEAR].response_date) return -1;

	return moment(a.renewals[YEAR].response_date)
	.isBefore(b.renewals[YEAR].response_date) ? -1 : 1;
}

function _category (a, b)
{
	let cat_a = a._category?.name || '';
	let cat_b = b._category?.name || '';

	if (!cat_a && !cat_b) return 0;

	if (!cat_a) return 1;

	if (!cat_b) return -1;

	return cat_a.toLowerCase().localeCompare(cat_b.toLowerCase());
}

function _name (a, b)
{
	return (a.name || '').toLowerCase()
	.localeCompare((b.name || '').toLowerCase());
}

var config = mergeDeep({ }, form);

mergeDeep(config, list);

export { config as list }

export default config